'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var __chunk_1 = require('../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var __chunk_6 = require('./gtmContext.js');

function GTMProvider(_ref) {
  var children = _ref.children,
      id = _ref.id,
      _ref$pageviewEventNam = _ref.pageviewEventName,
      pageviewEventName = _ref$pageviewEventNam === void 0 ? 'Pageview' : _ref$pageviewEventNam,
      _ref$dataLayer = _ref.dataLayer,
      dataLayer = _ref$dataLayer === void 0 ? 'dataLayer' : _ref$dataLayer;

  var _useState = React.useState(__chunk_6.types.INITIAL_PAGE_LOAD),
      _useState2 = __chunk_1.slicedToArray(_useState, 2),
      status = _useState2[0],
      setStatus = _useState2[1];

  var value = React.useMemo(function () {
    return {
      trackPageView: function trackPageView() {
        window[dataLayer] = window[dataLayer] || [];
        window[dataLayer].push({
          event: pageviewEventName,
          url: window.location.pathname
        });
      },
      trackCustomEvent: function trackCustomEvent(name) {
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        window[dataLayer] = window[dataLayer] || [];
        window[dataLayer].push(__chunk_1.objectSpread({
          event: name
        }, data));
      },
      status: status,
      setStatus: setStatus,
      types: __chunk_6.types
    };
  }, [status]);
  React.useEffect(function () {
    var persisted = localStorage.getItem('trackingAccepted') || __chunk_6.types.INDETERMINATE;

    if (Object.values(__chunk_6.types).indexOf(persisted) === -1) {
      persisted = __chunk_6.types.INDETERMINATE;
    }

    setStatus(persisted);
  }, []);
  React.useEffect(function () {
    if (status !== __chunk_6.types.INITIAL_PAGE_LOAD) {
      localStorage.setItem('trackingAccepted', status);
    }

    if (status === __chunk_6.types.ACCEPTED) {
      (function (f, u, c, k, d) {
        f[k] = f[k] || [];
        f[k].push({
          'gtm.start': new Date().getTime(),
          event: 'gtm.js'
        });
        var z = u.getElementsByTagName(c)[0],
            j = u.createElement(c),
            dl = k !== 'dataLayer' ? "&l=".concat(k) : '';
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=".concat(d).concat(dl); // @ts-ignore

        z.parentNode.insertBefore(j, z);
      })(window, document, 'script', dataLayer, id);
    }
  }, [status]);
  return React__default.createElement(__chunk_6.gtmContext.Provider, {
    value: value
  }, children);
}

exports.GTMProvider = GTMProvider;
